import i18n from '@/libs/i18n'
import useEntityCrud from '@/composable/useEntityCrud'

export default function useArticlesList() {
  function convertResource(resource, selectedLang) {
    return {
      ...resource,
      lang: selectedLang,
    }
  }

  const MODULE_NAME = 'specialists'
  const ENDPOINT = 'specialist'

  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)

  // Table Handlers
  const tableColumns = [
    {
      key: 'fullName', label: i18n.t('general.fullName'), sortable: true, icon: 'UserCheckIcon',
    },
    {
      key: 'clinicName', label: i18n.t('general.clinicName'), sortable: true, icon: 'LayersIcon',
    },
    {
      key: 'expertise', label: i18n.t('general.expertise'), sortable: true, icon: 'AwardIcon',
    },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), type: 'dateTime', sortable: true,
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), type: 'dateTime', sortable: true,
    },
  ]

  return {
    ...entity,
    convertResource,
    tableColumns,
  }
}
